import { theme } from "../../theme";

const TRUST_LEVELS = [
  { id: 'nylidi', label: 'Nýliði', icon: '🌱', color: '#94a3b8', minJobs: 0, minRating: 0 },
  { id: 'virki', label: 'Virki', icon: '⚡', color: '#38bdf8', minJobs: 3, minRating: 0 },
  { id: 'gull', label: 'Gullverktaki', icon: '🏆', color: '#f59e0b', minJobs: 10, minRating: 4.5 },
];

export function getTrustLevel(completedJobs = 0, rating = 0) {
  if (completedJobs >= 10 && rating >= 4.5) return TRUST_LEVELS[2];
  if (completedJobs >= 3) return TRUST_LEVELS[1];
  return TRUST_LEVELS[0];
}

export default function TrustBadge({ completedJobs = 0, rating = 0, size = "sm" }) {
  const level = getTrustLevel(completedJobs, rating);
  const fontSize = size === "sm" ? 10 : 12;
  const padding = size === "sm" ? "2px 6px" : "3px 8px";

  return (
    <span style={{
      display: "inline-flex", alignItems: "center", gap: 3,
      background: `${level.color}22`, border: `1px solid ${level.color}44`,
      borderRadius: 6, padding, fontSize, fontWeight: 600,
      color: level.color, whiteSpace: "nowrap",
    }}>
      {level.icon} {level.label}
    </span>
  );
}

export { TRUST_LEVELS };
